import React from "react";
import { AircraftsStore } from "@app/Stores/AircraftsStore";

export class AircraftsModuleStore {
    public aircraftStore: AircraftsStore;

    constructor() {
        this.aircraftStore = new AircraftsStore();
    }
}

export const AircraftsModuleContext = React.createContext<AircraftsModuleStore | null>(null);

export const AircraftsModuleProvider = ({ children }: React.PropsWithChildren) => {
    const store = React.useMemo(() => new AircraftsModuleStore(), []);

    return (
        <AircraftsModuleContext.Provider value={store}>
            {children}
        </AircraftsModuleContext.Provider>
    );
};
